const communities = [
  { name: "North Pole", zip: "99705" },
  { name: "Ester", zip: "99725" },
  { name: "Fox", zip: "99712" },
  { name: "Badger Road", zip: "99705" },
  { name: "Moose Creek", zip: "99705" },
  { name: "College", zip: "99701" },
  { name: "Fort Wainwright", zip: "99703" },
  { name: "Eielson AFB", zip: "99702" },
  { name: "Two Rivers", zip: "99716" },
  { name: "Salcha", zip: "99714" },
  { name: "Nenana", zip: "99760" },
  { name: "Delta Junction", zip: "99737" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Fairbanks &amp; All of Interior Alaska
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves the Fairbanks North Star Borough and all of Interior Alaska — including North Pole, Ester, Fort Wainwright, Eielson AFB, and outlying communities along the Parks, Richardson, and Steese highways. Residents ship documents to our registered office for expedited processing with no Seattle agency trip needed.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Nearest Passport Agency</h3>
              <p className="text-gray-600 text-sm mb-2">
                <strong>Seattle Passport Agency</strong> — 915 2nd Ave, Seattle, WA 98174
              </p>
              <p className="text-gray-500 text-sm mb-2">
                Distance from Fairbanks: 1,600+ miles — flight required, plus same-day appointment.
              </p>
              <p className="text-gray-500 text-sm">
                Fast Passport Center eliminates this trip entirely.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-5">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Interior Alaska Coverage</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We process passports for residents throughout Fairbanks (99701–99712), North Pole, Fort Wainwright, Eielson AFB, and communities throughout the Fairbanks North Star Borough.
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-[#1A365D] mb-5">Communities We Serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-lg px-4 py-3 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-[#F6C344] text-sm"></i>
                    </div>
                    <span className="text-sm font-semibold text-[#1A365D]">{c.name}</span>
                  </div>
                  <span className="text-xs text-gray-400">{c.zip}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}